module.exports = __webpack_public_path__ + "img/c773749.jpg";